module.exports = "/wwwroot/img/water_supply_link_block.png?ver=8fdddc10";